import { Link } from 'react-router-dom';

export default function Merits() {
  return (
    <>
      <section className="py-16 bg-gradient-to-b from-white to-teal-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            年会費無料カードを選ぶメリット
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-money-dollar-circle-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                維持コスト0円
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                年会費が一切かからないため、使わなくても損をしません。複数枚持ちにも最適です。
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-gift-line text-3xl text-emerald-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                特典が充実
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                年会費無料でも高還元率やポイントアップ特典など、お得なサービスが満載です。
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="w-16 h-16 bg-cyan-100 rounded-full flex items-center justify-center mb-4 mx-auto">
                <i className="ri-shield-check-line text-3xl text-cyan-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
                審査が通りやすい
              </h3>
              <p className="text-gray-600 text-center leading-relaxed">
                年会費無料カードは審査基準が比較的やさしく、初めての方でも作りやすいのが特徴です。
              </p>
            </div>
          </div>
          
          <div className="mt-12 bg-white rounded-xl p-8 shadow-md">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              こんな方におすすめ
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-500 text-xl mt-0.5"></i>
                <span className="text-gray-700">初めてクレジットカードを作る方</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-500 text-xl mt-0.5"></i>
                <span className="text-gray-700">維持費をかけずにポイントを貯めたい方</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-500 text-xl mt-0.5"></i>
                <span className="text-gray-700">複数のカードを使い分けたい方</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-line text-teal-500 text-xl mt-0.5"></i>
                <span className="text-gray-700">学生や主婦の方</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* 3️⃣ 記事途中にCTA追加 */}
      <section className="py-12 bg-teal-50">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-gradient-to-r from-teal-500 to-emerald-500 rounded-2xl p-8 text-white shadow-xl">
            <div className="flex items-center gap-2 mb-4">
              <div className="px-3 py-1 bg-white text-teal-600 text-xs font-bold rounded-full whitespace-nowrap">
                人気No.1
              </div>
              <div className="px-3 py-1 bg-yellow-400 text-gray-900 text-xs font-bold rounded-full whitespace-nowrap">
                年会費永年無料
              </div>
            </div>
            
            <h3 className="text-2xl font-bold mb-4">三井住友カード（NL）</h3>
            
            <p className="text-lg mb-6 opacity-95">
              対象のコンビニ・飲食店で最大7%還元。年会費永年無料で維持コスト0円。最短10秒でカード番号発行ですぐに使えます。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <Link 
                to="/mitsui"
                className="flex-1 px-6 py-4 bg-white text-teal-600 text-center rounded-lg hover:bg-gray-50 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
              >
                詳細ページを見る
              </Link>
              <a 
                href="#apply"
                className="flex-1 px-6 py-4 bg-yellow-400 text-gray-900 text-center rounded-lg hover:bg-yellow-300 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
              >
                公式サイトはこちら
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
